import { AppState } from '../states/app.state';
import { PostsState } from '../states/posts.state';
import { createSelector } from '@ngrx/store';

const PostsState = (state: AppState) => state.posts;

export const selectPosts = createSelector(
    PostsState,
    (state: PostsState) => state.posts
);
